<template>
  <div class="row">
    <div v-for="(field, index) in fields" :key="index" :class="containerClass">
      <FormMultiSelect
        v-if="field.type === 'select'"
        v-model="value[field.id]"
        :options="parseOptions(field.options)"
        :label="`${field.identity} ${field.required === 'yes' ? '*' : ''}`"
        :multiple="field.is_multiselect"
        optionLabel="name"
        optionTrackBy="id"
        :disabled="loading"
        :errors="validation.fields[field.id].errors"
        :dirty="validation.fields[field.id].dirty"
      />
      <FormInput
        v-if="field.type === 'text'"
        v-model="value[field.id]"
        :label="`${field.identity} ${field.required === 'yes' ? '*' : ''}`"
        :disabled="loading"
        :errors="validation.fields[field.id].errors"
        :dirty="validation.fields[field.id].dirty"
      />
      <FormTextArea
        v-if="field.type === 'textarea'"
        v-model="value[field.id]"
        :label="`${field.identity} ${field.required === 'yes' ? '*' : ''}`"
        :disabled="loading"
        :errors="validation.fields[field.id].errors"
        :dirty="validation.fields[field.id].dirty"
      />
    </div>
  </div>
</template>

<script>
import FormInput from "@/components/display/form/FormInput";
import FormMultiSelect from "@/components/display/form/FormMultiSelect";
import FormTextArea from "@/components/display/form/FormTextArea";

export default {
  name: "FormDynamicFields",
  props: {
    fields: Array,
    validation: Object,
    loading: Boolean,
    containerClass: String,
    value: Object,
  },
  components: {
    FormInput,
    FormMultiSelect,
    FormTextArea,
  },
  setup(props, { emit }) {
    const emitInput = () => {
      emit("input", props.value);
    };

    const parseOptions = (options) =>
      Object.keys(options).map((key) => ({
        id: Number(key),
        name: options[key],
      }));

    return {
      emitInput,
      parseOptions,
    };
  },
};
</script>
